export enum SearchContext {
  // Search
  TITLE = 'title',
  PROVIDER_TITLE_ID = 'ProviderTitleId',

  // Lookup
  MASTER_ID = 'masterId',
  PLATFORM_TITLE_ID = 'PlatformTitleId',
}
